import { render, staticRenderFns } from "./ConsultationTable.vue?vue&type=template&id=219cccf6&scoped=true&"
import script from "./ConsultationTable.vue?vue&type=script&lang=js&"
export * from "./ConsultationTable.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationTable.vue?vue&type=style&index=0&id=219cccf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219cccf6",
  null
  
)

export default component.exports